module.exports = require('../dist/contexts/AnchorContext');
